import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import toast from "react-hot-toast";
import api from "../../../../services/api";

export const Edit = ({ value, campaignId }) => {
  const [values, setValues] = useState(value);
  const [status, setStatus] = useState(value.fetchStatus !== "DONE");

  const navigate = useNavigate();

  const handleForm = async (e) => {
    e.preventDefault();
    try {
      const res = await api.put(`/githeo_campaign/${campaignId}`, values);
      if (!res.ok) throw res;
      toast.success("Updated !");
    } catch (e) {
      console.log("e", e);
      toast.error(e.code);
    }
  };

  const deleteData = async () => {
    try {
      if (!confirm("Are you sure ?")) return;
      const res = await api.remove(`/githeo_campaign/${campaignId}`);
      if (!res.ok) throw res;
      toast.success("Deleted !");
      navigate(`/githeo/campaigns`);
    } catch (e) {
      console.log("e", e);
      toast.error(e.code);
    }
  };
  return (
    <div className="bg-white shadow-topbar p-4.5 rounded-xl  p-4">
      <form onSubmit={handleForm} className="space-y-5 max-w-xl">
        <div>
          <div className="text-sm font-medium mb-2">Campaign name</div>
          <input className="border border-gray-300 w-full p-2 px-4 rounded-lg" value={values.name} required onChange={(e) => setValues({ ...values, name: e.target.value })} />
        </div>
        <div>
          <div className="text-sm font-medium mb-2">Github repos</div>
          <textarea
            placeholder="username/repository"
            className="border border-gray-300 w-full p-2 px-4 rounded-lg h-32"
            value={values.githubs}
            onChange={(e) => setValues({ ...values, githubs: getRepoName(e.target.value) })}
          />
        </div>
        <div className="flex items-center space-x-4">
          <div className="text-sm font-medium mb-2">Fetching Status</div>
          <div className="relative">
            <input
              className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-neutral-300 before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-neutral-100 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-nav-dark checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-indigo-500 checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-indigo-500 checked:focus:bg-nav-dark checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-indigo-500 dark:checked:after:bg-indigo-500 dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]"
              type="checkbox"
              role="switch"
              onClick={() => {
                setStatus((state) => !state);
                setValues({
                  ...values,
                  fetchStatus: !status ? "TO_RUN" : "DONE",
                });
              }}
              defaultChecked={status}
            />
          </div>
          <span className="text-gray-600">
            The Fetching status is <strong>{values.fetchStatus}</strong> at the moment
          </span>
        </div>

        <div className="flex items-center justify-between mt-10">
          <button className="bg-indigo-500 hover:bg-indigo-400 transition-all duration-200 text-white p-2 px-5 rounded-md text-base" type="submit">
            Update
          </button>
          <button
            className="border-indigo-500 border text-indigo-500 p-2 px-5 rounded-md text-base hover:bg-indigo-500 hover:text-white hover:border-indigo-500 transition-colors"
            type="button"
            onClick={deleteData}>
            Delete
          </button>
        </div>
      </form>
    </div>
  );
};

function getRepoName(url) {
  if (!url) return url;
  return url.replace("https://github.com/", "");
}
